/*
 * Copyright © 2017, Rezo Zero
 *
 * @file entry.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import {
    polyfills
} from 'starting-blocks'
import * as log from 'loglevel'
import App from './App';

(() => {
    // Config loglevel
    if (window.TEMP.debug && window.TEMP.debug === true) {
        log.setLevel(0)
    } else {
        log.setLevel(5)
    }

    // Declare polyfills
    polyfills()

    const app = new App()
    app.init()
})()



// WEBPACK FOOTER //
// ./webpack/js/entry.js